import { h } from '@stencil/core';
import { parseCommonURLToRouterParts } from '@pes-ui/utils';
import PesRoute from '../../../pes-router/pes-route';
import { isAppRoutingEnabled, navigateWithRouter } from '../../../pes-router/utils';
export class RangeLink {
  constructor() {
    this.linkClickHandler = (event) => {
      var _a;
      (_a = this.onLinkClick) === null || _a === void 0 ? void 0 : _a.call(this, event);
      if (isAppRoutingEnabled()) {
        event.preventDefault();
        navigateWithRouter(this.route, event.currentTarget);
      }
    };
    this.url = undefined;
    this.label = undefined;
    this.rangeName = undefined;
    this.onLinkClick = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.url);
      this.route = new PesRoute({ page: pageType, pageId });
      this.url = this.route.url;
    }
  }
  render() {
    return (h("div", { class: "link" }, h("qds-standalone-link", { "icon-name": "chevron-left", size: "small", href: this.url, onClick: this.linkClickHandler }, h("span", { class: "link__text", innerHTML: `${this.label} ${this.rangeName}` }))));
  }
  static get is() { return "pes-range-link"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["range-link.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["range-link.css"]
    };
  }
  static get properties() {
    return {
      "url": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "url for redirecting."
        },
        "attribute": "url",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "url label."
        },
        "attribute": "label",
        "reflect": false
      },
      "rangeName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "name of the range"
        },
        "attribute": "range-name",
        "reflect": false
      },
      "onLinkClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(e: MouseEvent)=>void",
          "resolved": "(e: MouseEvent) => void",
          "references": {
            "MouseEvent": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Callback for saving breadcrumbs in indexDB"
        }
      }
    };
  }
  static get elementRef() { return "el"; }
}
